import axios from "axios";
import {baseUrlPromo, xApiKeyPromo} from "../../config/api/apiConfig";

class PromoServices {
    private axios = axios.create({
        baseURL: baseUrlPromo,
    });

    public async getDetailCommission(params?: { companyCode?: any, commissionCode?: any, transactionType?: string, fincoCode?: number, ignoreTransactionDate?: string, agentCode?: string, loan?: any, tenor?: any, category?: any }) {
        const queries: any = {
            promo_type: 'new_vehicle',
            ...(params?.fincoCode && {
                finco_code: params.fincoCode,
            }),
            ...(params?.ignoreTransactionDate && {
                ignore_transaction_date: params.ignoreTransactionDate,
            }),
            ...(params?.agentCode && {
                agent_code: params.agentCode,
            }),
            ...(params?.transactionType && {
                transaction_type: params.transactionType,
            }),
            ...(params?.loan && {
                loan: params.loan,
            }),
            ...(params?.tenor && {
                tenor: params.tenor,
            }),
            ...(params?.category && {
                category: params.category,
            })
        }

        try {
            const dataFetchDetailPromo = await this.axios.get<any>(`/commission/${params?.companyCode}/${params?.commissionCode}`, {
                headers: {"X-Api-Key": xApiKeyPromo,},
                params: {...queries,}
            });

            return dataFetchDetailPromo.data.data;
        } catch (e: any) {
            throw new Error(e?.response?.data?.error?.message);
        }
    }
}

export const promoServices = new PromoServices();